import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { scrollToId } from "@/App";

const links = [
  { label: "The Vision", href: "#vision", testid: "nav-link-vision" },
  { label: "Waitlist", href: "#waitlist", testid: "nav-link-waitlist" },
  { label: "Custom Application", href: "#apply", testid: "nav-link-apply" },
];

export default function Header() {
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 40));

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled
          ? "bg-[#F4EEE3]/90 backdrop-blur-xl border-[#221812]/15"
          : "bg-transparent border-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-12">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-caps text-sm sm:text-base font-semibold uppercase tracking-[0.4em] text-[#221812] transition-colors duration-300 hover:text-[#5E1A22]"
          data-testid="header-wordmark"
          aria-label="SANZONE — back to top"
        >
          Sanzone
        </button>
        <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollToId(l.href)}
              className="text-xs uppercase tracking-[0.25em] text-[#55504A] transition-colors duration-300 hover:text-[#221812]"
              data-testid={l.testid}
            >
              {l.label}
            </button>
          ))}
          <span className="font-code hidden text-[10px] uppercase tracking-[0.3em] text-[#8C857B] lg:inline">
            [ Prelaunch — 2027 ]
          </span>
        </nav>
        <button
          onClick={() => scrollToId("#waitlist")}
          className="border border-[#221812]/50 px-4 py-2 text-[11px] sm:text-xs uppercase tracking-[0.25em] text-[#221812] transition-colors duration-300 hover:bg-[#221812] hover:text-[#F4EEE3]"
          data-testid="header-join-waitlist-btn"
        >
          Join the Waitlist
        </button>
      </div>
    </motion.header>
  );
}
